module.exports = __webpack_public_path__ + "static/img/3-2.2f31cd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3-2.png
// module id = rlVV
// module chunks = 1